module.exports = __webpack_public_path__ + "img/server_d250.a0665afc.svg";